import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // This will scroll to top on all route changes
    console.log("ScrollToTop: Navigated to", pathname);
    
    // Using setTimeout to ensure the DOM has updated before scrolling
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto' // Use 'auto' instead of 'smooth' for immediate scrolling
      });
    }, 0);
  }, [pathname, search, hash]); // Listen to all location changes

  return null;
}